//Third-party
import { useMemo } from "react";

// Material
import { Box } from "@mui/material";
import { GridColDef, DataGridProProps } from "@mui/x-data-grid-pro";
import { useGridApiRef } from "@mui/x-data-grid-premium";

// Components
import DataSmartTable from "@Layouts/components/Tables/DataSmartTable";

// Helpers
import { generateTreeData, getPropertiesList } from "@/DataPages/components/common/ListColumnDialog/helpers/ListColumnDialog";

// Types
import CustomCell from "@/Layouts/components/Tables/DataSmartTable/additional/CustomCell";

interface IObjectDetailsProps {
	item: object;
}

const ObjectDetails = (props: IObjectDetailsProps) => {
	const { item } = props;

	const apiRef = useGridApiRef();
	const pixelsPerChar = 23;

	const initialRows = useMemo(() => {
		return getPropertiesList(item);
	}, [item]);

	const rows = generateTreeData(initialRows);

	const maxPathLength = rows.reduce((acc, current) => {
		return current.path.length > acc ? current.path.length : acc;
	}, 0);

	const columns: GridColDef[] = [
		{
			field: "_id",
			headerName: "ID",
			width: 5,
			filterable: false,
		},
		{
			field: "label",
			headerName: "",
			width: 232,
			renderCell: (params) => {
				const nestedLevel = maxPathLength - params.row.path.length;
				const paddingLeft = nestedLevel * pixelsPerChar;

				return (
					<Box sx={{ position: "fixed", width: "300px", marginLeft: `-${paddingLeft}px` }}>
						<CustomCell value={params.value} hasTooltip maxWith={params.colDef.width ?? 0} fontSize="12px" />
					</Box>
				);
			},
		},
	];

	const getTreeDataPath: DataGridProProps["getTreeDataPath"] = (row) => row.path;

	const groupingColDef = {
		headerName: "",
		minWidth: maxPathLength * pixelsPerChar,
		width: maxPathLength * pixelsPerChar,
		hideDescendantCount: true,
		valueFormatter: () => "",
	};

	return (
		<DataSmartTable
			treeData
			getTreeDataPath={getTreeDataPath}
			groupingColDef={groupingColDef}
			apiRef={apiRef}
			columns={columns}
			rows={rows}
			headerHeight={0}
			defaultGroupingExpansionDepth={0}
			rowHeight={25}
			disableColumnMenu
			disableColumnSelector
			disableColumnResize
			disableColumnReorder
			disableColumnSorting
			columnVisibilityModel={{ _id: false }}
			enableCustomScrollbars
			customProps={{
				tableClassName: {
					"!w-full functional-table footer-table-included": true,
					"[&_.MuiDataGrid-treeDataGroupingCellToggle>button]:!w-[24px]": true,
					"[&_.MuiDataGrid-treeDataGroupingCellToggle>button]:!h-[24px]": true,
					"[&_.MuiDataGrid-main]:!h-auto": true,
					"!overflow-x-visible": true,
				},
				aggregationFooterClassName: "aggregation-footer regular-footer",
				expandableRows: false,
				hide: false,
			}}
		/>
	);
};

export default ObjectDetails;
